import React, {
    createContext,
    useContext,
    useState,
    useCallback,
    useEffect
} from 'react';
import axios from '../services/api';
import ENDPOINTS from '../constants/endpoints';
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {ROUTES} from "../constants/PathRoutes";
import {message} from "antd";
import ProtectedClientRoute from "../components/ProtectedClientRoute";

const ClientAuthContext = createContext(null);

export const useClientAuth = () => {
    const context = useContext(ClientAuthContext);
    if (!context) {
        throw new Error('useClientAuth deve ser usado dentro de ClientAuthProvider');
    }
    return context;
};

export const ClientAuthProvider = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    const fetchMe = useCallback(async (throwError = false) => {
        try {
            const response = await axios.get(ENDPOINTS.AUTH_ME);
            const userData = response.data;

            if (userData.type === 'Client') {
                setUser(userData);
            }
        } catch (error) {
            setUser(null);
            if (throwError) {
                throw Error('');
            }
        }
    }, []);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                await fetchMe(true);
                if (location.pathname === ROUTES.LOJA_HOME) {
                    navigate(ROUTES.LOJA_HOME);
                }
            } catch (error) {
                if (location.pathname !== ROUTES.LOJA_HOME && location.pathname.startsWith('/loja')) {
                    message.warning('Você não possui um usuário logado');
                    navigate(ROUTES.AREA_ASSOCIADO_LOGIN, {replace: true});
                }
            } finally {
                setLoading(false);
            }
        };
        checkAuth();
    }, [fetchMe]);

    const login = async (username, password) => {
        setLoading(true);
        try {
            await axios.post(ENDPOINTS.AUTH_LOGIN_CLIENT, {username, password});
            await fetchMe();
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        axios.post(ENDPOINTS.AUTH_LOGOUT).catch(() => {});
        setUser(null);
    };

    const isAuthenticated = () => {
        return !!user && user.type === 'Client';
    };

    const value = {
        user,
        login,
        logout,
        isAuthenticated,
        loading,
        fetchMe,
    };

    return (
        <ClientAuthContext.Provider value={value}>
            <ProtectedClientRoute><Outlet/></ProtectedClientRoute>
        </ClientAuthContext.Provider>
    );
};